import React, { useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";

import { leadsData } from "../../core/data/json/leads";
import { Modal } from "react-bootstrap";
import { TableData } from "../../core/data/interface";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import CollapseHeader from "../../core/common/collapse-header";
import { SelectWithImage2 } from "../../core/common/selectWithImage2";
import { all_routes } from "../router/all_routes";
import { TagsInput } from "react-tag-input-component";
import Offcanvas from "react-bootstrap/Offcanvas";
const Report = () => {
  const route = all_routes;
  const [adduser, setAdduser] = useState(false);
  const [addcompany, setAddCompany] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Lead");
  const data = leadsData;
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow(false);
  const handleShow2 = () => setShow(true);
  const handleClose3 = () => setShow(false);
  const handleShow3 = () => setShow(true);
  const togglePopup = (isEditing: any) => {
    setModalTitle(isEditing ? "Edit Lead" : "Add New Lead");
    setAdduser(!adduser);
  };
  const addcompanyPopup = () => {
    setAddCompany(!addcompany);
  };

  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const columns = [
    {
      title: "",
      dataIndex: "",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
    {
      title: "Campaign",
      dataIndex: "Campaign",
      key: "Campaign",
      render: (text: any) => (
        <Link to={route.leadsactivity} className="title-name">
          {text}
        </Link>
      ),
      sorter: (a: TableData, b: TableData) =>
        a.lead_name.length - b.lead_name.length,
    },

    {
      title: "List",
      render: (text: any, record: any) => (
        <h2 className="d-flex align-items-center">
          <Link
            to={route.companyDetails}
            className="avatar avatar-sm border rounded p-1 me-2"
          >
            <ImageWithBasePath
              className="w-auto h-auto"
              src={record.image}
              alt="User Image"
            />
          </Link>
          <Link to={route.companyDetails} className="d-flex flex-column">
            {record.company_name}
            <span className="text-default">{text.company_address} </span>
          </Link>
        </h2>
      ),
    },
    {
      title: "Disposition",
      dataIndex: "Disposition",
      key: "disposition",
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Day",
      dataIndex: "Day",
      key: "day",
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Time",
      dataIndex: "Time",
      key: "time",
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Call Time",
      dataIndex: "Call Time",
      key: "calltime",
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Recycle Status",
      dataIndex: "status",
      render: (text: string) => (
        <div>
          {text === "Closed" && (
            <span className="badge badge-pill badge-status bg-success">
              {text}
            </span>
          )}
          {text === "Connected" && (
            <span className="badge badge-pill badge-status bg-warning">
              {text}
            </span>
          )}
          {text === "Lost" && (
            <span className="badge badge-pill badge-status bg-danger">
              {text}
            </span>
          )}
          {text === "Not connected" && (
            <span className="badge badge-pill badge-status bg-pending">
              {text}
            </span>
          )}
        </div>
      ),
      sorter: true,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-target="#offcanvas_edit"
              data-bs-toggle="offcanvas"
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>

            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_lead"
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>

            <Link className="dropdown-item" to="#">
              <i className="ti ti-clipboard-copy text-blue-light" /> clone
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
  };
  const [newContents, setNewContents] = useState<number[]>([0]);

  const addNewContent = () => {
    setNewContents([...newContents, newContents.length]);
  };

  const currency = [
    { value: "Choose", label: "Choose" },
    { value: "Dollar", label: "Dollar" },
    { value: "Euro", label: "Euro" },
    { value: "Pound", label: "Pound" },
    { value: "Rupee", label: "Rupee" },
  ];

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                        Recycle Rule<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center mb-3">
                      <div className="col-sm-4">
                        <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                          
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={handleShow2}
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Add Recycle Rule
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                    {/* form */}
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        <div className="form-group ">
                          <label className="form-label">Campaign</label>
                          <div className="input-group mb-3">
                            <span className="input-group-text ">
                              <i className="ti-list"></i>
                            </span>
                            <select
                              name="campaign_id"
                              className="form-select"
                              id="search-campaign-rule"
                            >
                              <option value="">Select</option>
                              <option value="45">Copy webRTC campaign</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group ">
                          <label className="form-label">List </label>
                          <div className="input-group mb-3">
                            <span className="input-group-text ">
                              <i className="ti-list"></i>
                            </span>
                            <select
                              name="list_id"
                              className="form-select"
                              id="search-list-rule"
                            >
                              <option value="">Select List</option>
                              <option value="44">Test List</option>
                              <option value="99">Abhishek</option>
                              <option value="106">shikhaa</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group ">
                          <label className="form-label">Disposition </label>
                          <div className="input-group mb-3">
                            <select
                              name="disposition_id"
                              className="form-select"
                              id="search-disposition-rule"
                            >
                              <option value="">Select Disposition</option>
                              <option value="5">Busy</option>
                              <option value="9">Call Back</option>
                              <option value="104">Cancelled By User</option>
                              <option value="108">Click2Call</option>
                              <option value="111">clickable</option>
                              <option value="112">clickable</option>
                              <option value="7">Disconnected</option>
                              <option value="4">Do Not Call</option>
                              <option value="1">No Answer</option>
                              <option value="8">No longer in Business</option>
                              <option value="2">Not Interested</option>
                              <option value="110">Outbound AI Dialed</option>
                              <option value="11">Sale - (Survey Done)</option>
                              <option value="3">Sale Made</option>
                              <option value="6">Wrong Number</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-4">
                        <div className="form-group ">
                          <label className="col-form-label ">Day </label>
                          <div className="input-group mb-3" id="date-range1">
                            <span className="input-group-text ">
                              <i className="ti-list"></i>
                            </span>
                            <select
                              name="days"
                              className="form-select"
                              id="search-days-rule"
                            >
                              <option value="">Select Day</option>

                              <option value="sunday">Sunday</option>
                              <option value="monday">Monday</option>
                              <option value="tuesday">Tuesday</option>
                              <option value="wednesday">Wednesday</option>
                              <option value="thursday">Thursday</option>
                              <option value="friday">Friday</option>
                              <option value="saturday">Saturday</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group ">
                          <label className="col-form-label ">Call Time </label>
                          <div className="input-group mb-3" id="date-range1">
                            <span className="input-group-text ">
                              <i className="ti-list"></i>
                            </span>
                            <select
                              name="call_time"
                              className="form-select"
                              id="search-calltime-rule"
                            >
                              <option value="">Select Call Time</option>

                              <option value="1">1</option>
                              <option value="2">
                                {" "}
                                less than or equal to 2
                              </option>
                              <option value="3">
                                {" "}
                                less than or equal to 3
                              </option>
                              <option value="4">less than or equal to 4</option>
                              <option value="5">less than or equal to 5</option>
                              <option value="6">less than or equal to 6</option>
                              <option value="7">less than or equal to 7</option>
                              <option value="8">less than or equal to 8</option>
                              <option value="9">less than or equal to 9</option>
                              <option value="10">
                                less than or equal to 10
                              </option>
                              <option value="11">
                                less than or equal to 11
                              </option>
                              <option value="12">
                                less than or equal to 12
                              </option>
                              <option value="13">
                                less than or equal to 13
                              </option>
                              <option value="14">
                                less than or equal to 14
                              </option>
                              <option value="15">
                                less than or equal to 15
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group ">
                          <label className="col-form-label ">Time </label>
                          <div className="input-group mb-3" id="date-range1">
                            <input
                              className="form-control"
                              type="time"
                              value="09:30"
                              name="time"
                              id="timepicker6"
                            />

                            <span
                              className="input-group-addon bg-primary text-white b-0"
                              style={{ padding: "10px" }}
                            >
                              to
                            </span>
                            <input
                              type="time"
                              className="form-control"
                              value="09:30"
                              name="time"
                              id="timepicker9"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setOpenModal2(true)}
                      >
                        Search
                      </button>
                    </div>
                    {/* form*/}
                  </div>
                  <div className="card-body">
                    {/* Filter */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                        <div className="dropdown me-2">
                          <Link
                            to="#"
                            className="dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <i className="ti ti-sort-ascending-2 me-2" />
                            Sort
                          </Link>
                          <div className="dropdown-menu  dropdown-menu-start">
                            <ul>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Ascending
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Descending
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Recently Viewed
                                </Link>
                              </li>
                              <li>
                                <Link to="#" className="dropdown-item">
                                  <i className="ti ti-circle-chevron-right me-1" />
                                  Recently Added
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="icon-form">
                          <span className="form-icon">
                            <i className="ti ti-calendar" />
                          </span>
                          <DateRangePicker initialSettings={initialSettings}>
                            <input
                              className="form-control bookingrange"
                              type="text"
                            />
                          </DateRangePicker>
                        </div>
                      </div>
                 
                    </div>
                    {/* /Filter */}
                    {/* Contact List */}
                    <div className="table-responsive custom-table">
                      <Table dataSource={data} columns={columns} />
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                    {/* /Contact List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
        
        {/* Add Company */}
        <Offcanvas show={show} onHide={handleClose} placement="end">
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold"> Add Recycle Rule</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              onClick={handleClose}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="row align-items-center">
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Campaign</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-list"></i>
                      </span>
                      <select
                        name="campaign_id"
                        className="form-select"
                        id="search-campaign-rule"
                      >
                        <option value="">Select</option>
                        <option value="45">Copy webRTC campaign</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">List </label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-list"></i>
                      </span>
                      <select
                        name="list_id"
                        className="form-select"
                        id="search-list-rule"
                      >
                        <option value="">Select List</option>
                        <option value="44">Test List</option>
                        <option value="99">Abhishek</option>
                        <option value="106">shikhaa</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Disposition </label>
                    <div className="input-group mb-3">
                      <select
                        name="disposition_id"
                        className="form-select"
                        id="search-disposition-rule"
                      >
                        <option value="">Select Disposition</option>
                        <option value="5">Busy</option>
                        <option value="9">Call Back</option>
                        <option value="104">Cancelled By User</option>
                        <option value="108">Click2Call</option>
                        <option value="111">clickable</option>
                        <option value="112">clickable</option>
                        <option value="7">Disconnected</option>
                        <option value="4">Do Not Call</option>
                        <option value="1">No Answer</option>
                        <option value="8">No longer in Business</option>
                        <option value="2">Not Interested</option>
                        <option value="110">Outbound AI Dialed</option>
                        <option value="11">Sale - (Survey Done)</option>
                        <option value="3">Sale Made</option>
                        <option value="6">Wrong Number</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="col-form-label ">Day </label>
                    <div className="input-group mb-3" id="date-range1">
                      <span className="input-group-text ">
                        <i className="ti-list"></i>
                      </span>
                      <select
                        name="days"
                        className="form-select"
                        id="search-days-rule"
                      >
                        <option value="">Select Day</option>

                        <option value="sunday">Sunday</option>
                        <option value="monday">Monday</option>
                        <option value="tuesday">Tuesday</option>
                        <option value="wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="col-form-label ">Call Time </label>
                    <div className="input-group mb-3" id="date-range1">
                      <span className="input-group-text ">
                        <i className="ti-list"></i>
                      </span>
                      <select
                        name="call_time"
                        className="form-select"
                        id="search-calltime-rule"
                      >
                        <option value="">Select Call Time</option>

                        <option value="1">1</option>
                        <option value="2"> less than or equal to 2</option>
                        <option value="3"> less than or equal to 3</option>
                        <option value="4">less than or equal to 4</option>
                        <option value="5">less than or equal to 5</option>
                        <option value="6">less than or equal to 6</option>
                        <option value="7">less than or equal to 7</option>
                        <option value="8">less than or equal to 8</option>
                        <option value="9">less than or equal to 9</option>
                        <option value="10">less than or equal to 10</option>
                        <option value="11">less than or equal to 11</option>
                        <option value="12">less than or equal to 12</option>
                        <option value="13">less than or equal to 13</option>
                        <option value="14">less than or equal to 14</option>
                        <option value="15">less than or equal to 15</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="col-form-label ">Time </label>
                    <div className="input-group mb-3" id="date-range1">
                      <input
                        className="form-control"
                        type="time"
                        value="09:30"
                        name="time"
                        id="timepicker6"
                      />

                      <span
                        className="input-group-addon bg-primary text-white b-0"
                        style={{ padding: "10px" }}
                      >
                        to
                      </span>
                      <input
                        type="time"
                        className="form-control"
                        value="09:30"
                        name="time"
                        id="timepicker9"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setOpenModal2(true)}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </Offcanvas>
        {/* /Add Company */}
        {/* Edit Lead */}
        {/* <Offcanvas show={show3}  onHide={handleClose3} placement="end" >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Edit Lead</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              onClick={handleClose3}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="row">
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Lead Name <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <div className="radio-wrap">
                      <label className="col-form-label">Lead Type</label>
                      <div className="d-flex flex-wrap">
                        <div className="me-2">
                          <input
                            type="radio"
                            className="status-radio"
                            id="person"
                            name="leave"
                            defaultChecked
                          />
                          <label htmlFor="person">Person</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            className="status-radio"
                            id="Organization"
                            name="leave"
                          />
                          <label htmlFor="Organization">Organization</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <label className="col-form-label">Company Name</label>
                      <Link
                        to=""
                        className="label-add "
                        onClick={handleShow}
                      >
                        <i className="ti ti-square-rounded-plus" />
                        Add New
                      </Link>
                    </div>
                    <Select
                      className="select"
                      options={options}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Value<span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Currency <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="select"
                      options={currency}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                {newContents.map((index) => (
                  <div className="col-md-12" key={index}>
                    <div className="add-product-new">
                      <div className="row align-items-end">
                        <div className="col-md-8">
                          <div className=" mb-3">
                            <label className="col-form-label">
                              Phone <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              defaultValue="+1 875455453"
                            />
                          </div>
                        </div>
                        <div className="col-md-4 d-flex align-items-center">
                          <div className=" w-100 mb-3">
                            <Select
                              className="select"
                              options={optionschoose}
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-md-12">
                  <Link
                    onClick={addNewContent}
                    to="#"
                    className="add-new add-new-phone mb-3 d-block"
                  >
                    <i className="ti ti-square-rounded-plus me-2" />
                    Add New
                  </Link>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Source <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="select"
                      options={optionsource}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Industry <span className="text-danger">*</span>
                    </label>
                    <Select
                      className="select"
                      options={optionindustry}
                      classNamePrefix="react-select"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">Owner</label>
                    <SelectWithImage2 />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="col-form-label">Tags </label>
                    <TagsInput
                      // className="input-tags form-control"
                      value={owner}
                      onChange={setOwner}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows={5}
                      defaultValue={""}
                    />
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="mb-3">
                    <label className="col-form-label">Visibility</label>
                    <div className="d-flex flex-wrap">
                      <div className="me-2">
                        <input
                          type="radio"
                          className="status-radio"
                          id="public"
                          name="visible"
                        />
                        <label htmlFor="public">Public</label>
                      </div>
                      <div className="me-2">
                        <input
                          type="radio"
                          className="status-radio"
                          id="private"
                          name="visible"
                        />
                        <label htmlFor="private">Private</label>
                      </div>
                      <div data-bs-toggle="modal" data-bs-target="#access_view">
                        <input
                          type="radio"
                          className="status-radio"
                          id="people"
                          name="visible"
                        />
                        <label htmlFor="people">Select People</label>
                      </div>
                    </div>
                  </div>
                  <div className="mb-0">
                    <label className="col-form-label">Status</label>
                    <div className="d-flex flex-wrap">
                      <div className="me-2">
                        <input
                          type="radio"
                          className="status-radio"
                          id="active"
                          name="status"
                          defaultChecked
                        />
                        <label htmlFor="active">Active</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          className="status-radio"
                          id="inactive"
                          name="status"
                        />
                        <label htmlFor="inactive">Inactive</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setOpenModal2(true)}
                >
                  Create
                </button>
              </div>
            </form>
          </div>
        </Offcanvas> */}
        <div
          className="offcanvas  "
          style={{ width: "650px", right: "0", top: "0" }}
          tabIndex={-1}
          id="offcanvas_edit"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="fw-semibold">Edit Recycle Rule</h5>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Campaign</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <select
                        name="campaign_id"
                        className="form-select"
                        id="campaign"
                      >
                        <option value="6">SMPL</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">List</label>
                    <div className="input-group mb-3">
                      <select
                        name="list_id"
                        className="form-select"
                        id="list-rule"
                      >
                        <option value="">Select Lists</option>
                        <option value="44">Test List</option>
                        <option value="45">test</option>
                        <option value="46">nil</option>
                        <option value="47">dwed</option>
                        <option value="49">nov 19-more</option>
                        <option value="51">test list nov 22</option>
                        <option value="90">New test</option>
                        <option value="99">Abhishek</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Disposition</label>
                    <div className="input-group mb-3">
                      <select
                        className="select2 form-select select2-hidden-accessible"
                        name="disposition_id"
                        data-placeholder="Select Disposition"
                        
                      >
                        <option value="">select disposition</option>
                        <option value="5">Busy</option>
                        <option value="9">Call Back</option>
                        <option value="104">Cancelled By User</option>
                        <option value="108">Click2Call</option>
                        <option value="111">clickable</option>
                        <option value="112">clickable</option>
                        <option value="7"> Disconnected</option>
                        <option value="4">Do Not Call</option>
                        <option value="1">No Answer</option>
                        <option value="8">No longer in Business</option>
                        <option value="2">Not Interested</option>
                        <option value="110">Outbound AI Dialed</option>
                        <option value="11">Sale - (Survey Done)</option>
                        <option value="3">Sale Made</option>
                        <option value="6">Wrong Number</option>
                      </select>
                      <span
                        className="select2 select2-container select2-container--default"
                        dir="ltr"
                      >
                      
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Time</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="fa fa-clock"></i>
                      </span>
                      <input
                        type="time"
                        className="form-control"
                        value="09:30:00"
                        name="time"
                        id="timepicker"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Day</label>
                    <div className="input-group mb-3 ">
                      <select
                        className="select2 form-select select2-hidden-accessible"
                        name="days"
                        data-placeholder="Select Days"
                        aria-hidden="true"
                      >
                        <option value="sunday">Sunday</option>
                        <option value="monday">Monday</option>
                        <option value="tuesday">Tuesday</option>
                        <option value="wednesday">Wednesday</option>
                        <option value="thursday">Thursday</option>
                        <option value="friday">Friday</option>
                        <option value="saturday">Saturday</option>
                      </select>
                      <span
                        className="select2 select2-container select2-container--default"
                        dir="ltr"
                      >
                       
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group ">
                    <label className="form-label">Call Time</label>
                    <div className="input-group mb-3">
                      <span className="input-group-text ">
                        <i className="ti-email"></i>
                      </span>
                      <select
                        name="call_time"
                        className="form-select"
                        id="calltime-rule"
                      >
                        <option value="1">1</option>
                        <option value="2"> less than or equal to 2</option>
                        <option value="3"> less than or equal to 3</option>
                        <option value="4">less than or equal to 4</option>
                        <option value="5">less than or equal to 5</option>
                        <option value="6">less than or equal to 6</option>
                        <option value="7">less than or equal to 7</option>
                        <option value="8">less than or equal to 8</option>
                        <option value="9">less than or equal to 9</option>
                        <option value="10">less than or equal to 10</option>
                        <option value="11">less than or equal to 11</option>
                        <option value="12">less than or equal to 12</option>
                        <option value="13">less than or equal to 13</option>
                        <option value="14">less than or equal to 14</option>
                        <option value="15">less than or equal to 15</option>
                      </select>
                    </div>
                  </div>
                </div>

              </div>
              <div className="d-flex align-items-center justify-content-end">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="offcanvas"
                >
                  Cancel
                </Link>
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-primary me-2"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Edit Lead */}
        {/* Delete Lead */}
        <div className="modal fade" id="delete_lead" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove Lead?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> lead you selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Lead */}
        {/* Create Lead */}
        <Modal show={openModal2} onHide={() => setOpenModal2(false)}>
          <div className="modal-header border-0 m-0 justify-content-end">
            <button
              className="btn-close"
              onClick={() => setOpenModal2(false)}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="success-message text-center">
              <div className="success-popup-icon bg-light-blue">
                <i className="ti ti-building" />
              </div>
              <h3>Lead Created Successfully!!!</h3>
              <p>View the details of lead, created</p>
              <div className="col-lg-12 text-center modal-btn">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <Link
                  to={route.leadsactivity}
                  onClick={() => setOpenModal2(false)}
                  className="btn btn-primary"
                >
                  View Details
                </Link>
              </div>
            </div>
          </div>
        </Modal>
        {/* /Create Lead */}
        {/* Create Company */}
        <Modal show={openModal} onHide={() => setOpenModal(false)}>
          <div className="modal-header border-0 m-0 justify-content-end">
            <button
              className="btn-close"
              onClick={() => setOpenModal(false)}
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="modal-body">
            <div className="success-message text-center">
              <div className="success-popup-icon bg-light-blue">
                <i className="ti ti-building" />
              </div>
              <h3>Company Created Successfully!!!</h3>
              <p>View the details of company, created</p>
              <div className="col-lg-12 text-center modal-btn">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <Link
                  to={route.companyDetails}
                  onClick={() => setOpenModal(false)}
                  className="btn btn-primary"
                >
                  View Details
                </Link>
              </div>
            </div>
          </div>
        </Modal>
        {/* /Create Company */}
        {/* Add New View */}
        <div className="modal custom-modal fade" id="save_view" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New View</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="col-form-label">View Name</label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="modal-btn text-end">
                    <Link
                      to="#"
                      className="btn btn-light"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-danger"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Add New View */}
        {/* Access */}
        <div className="modal custom-modal fade" id="access_view" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Access For</h5>
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-2 icon-form">
                    <span className="form-icon">
                      <i className="ti ti-search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search"
                    />
                  </div>
                  <div className="access-wrap">
                    <ul>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-19.jpg"
                              alt=""
                            />
                            <Link to="#">Darlee Robertson</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-20.jpg"
                              alt=""
                            />
                            <Link to="#">Sharon Roy</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-21.jpg"
                              alt=""
                            />
                            <Link to="#">Vaughan</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-01.jpg"
                              alt=""
                            />
                            <Link to="#">Jessica</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-16.jpg"
                              alt=""
                            />
                            <Link to="#">Carol Thomas</Link>
                          </span>
                        </label>
                      </li>
                      <li className="select-people-checkbox">
                        <label className="checkboxs">
                          <input type="checkbox" />
                          <span className="checkmarks" />
                          <span className="people-profile">
                            <ImageWithBasePath
                              src="assets/img/profiles/avatar-22.jpg"
                              alt=""
                            />
                            <Link to="#">Dawn Mercha</Link>
                          </span>
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div className="modal-btn text-end">
                    <Link
                      to="#"
                      className="btn btn-light"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Confirm
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* /Access */}
      </>
    </>
  );
};

export default Report;
